import type {AppThunk} from '../../../actions/types'
import {getProjectPageArg, getSingleProjectArg, overviewArg} from '../../../rest/projects'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../routes/loadEndpoint'
import {restApi} from '../../../services/rest'
import type {ProjectId} from '../../../types'

export const preloadProjectToolbar =
  ({
    projectId,
    onlyFavorites,
  }: {
    projectId: ProjectId
    onlyFavorites?: boolean
  }): AppThunk<LoadedEndpoints> =>
  dispatch =>
    onlyFavorites
      ? [dispatch(loadEndpoint(restApi.endpoints.getSidebarProjectsNormalized, overviewArg))]
      : [
          dispatch(
            loadEndpoint(restApi.endpoints.getProjectNormalized, getSingleProjectArg(projectId)),
          ),
          dispatch(
            loadEndpoint(restApi.endpoints.getAllProjectsNormalized, getProjectPageArg(projectId)),
          ),
        ]
